import {Component, Host, HostListener, Input, TemplateRef} from '@angular/core';
import {AccordionGroupComponent} from './accordion.group.component';


@Component({
    selector: 'accordion-toggle',
    template: require('./accordion.toggle.template.html')
})
export class AccordionToggleComponent {

    @Input() title: string;
    @Input() rightBlockTmpl: TemplateRef<any>;

    constructor(@Host() private accordionGroup: AccordionGroupComponent) {
    }

    @HostListener('click')
    onClick() {
        this.accordionGroup.toggle();
    }

    getIconClass() {
        return {
            'fa': true,
            'fa-chevron-up': this.accordionGroup.isOpened,
            'fa-chevron-down': !this.accordionGroup.isOpened
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/accordion/accordion.toggle.component.ts